import { render, staticRenderFns } from "./feedbackManage.vue?vue&type=template&id=1a980b28&scoped=true"
import script from "./feedbackManage.vue?vue&type=script&lang=js"
export * from "./feedbackManage.vue?vue&type=script&lang=js"
import style0 from "./feedbackManage.vue?vue&type=style&index=0&id=1a980b28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a980b28",
  null
  
)

export default component.exports